module.exports = __webpack_public_path__ + "img/lib_region_flag_za.971ddeb8.png";